import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import GerenciarAssociados from '../TabelaGerenciarAssociados/GerenciarAssociados';

import MultiMatchFilter from '../../../shared/components/CampoMultiplosInputs/MatchFilter/MultiMatchFilter';
import { retornaListaMatchPorListaCampo } from '../../../../Utilitarios';

const opcoesDeFiltro = ['CNPJ', 'E-mail', 'Proprietário', 'Razão Social']

const campoPorOpcao = {
    'E-mail': 'usuario.email',
    'Razão Social': 'cadastro.social_name',
    'Proprietário': 'cadastro.owner',
    'CNPJ': 'cadastro.cnpj',
}

const criaFiltroVazio = () => ({
    id: `${Date.now()}-${Math.random()}`,
    campo: "",
    valor: "",
})

export default function FilterAssociadoTable({ onClick, listaAssociados, tituloToolbar, children }) {
    const [filtrado, setFiltrado] = useState([])
    const [filtros, setFiltros] = useState([criaFiltroVazio()])

    useEffect(() => {
        setFiltrado(listaAssociados)
    }, [listaAssociados])

    useEffect(() => {
        const filtrosPreenchidos = filtros.filter(filtro => filtro.campo !== "" && filtro.valor !== "")

        if(filtrosPreenchidos.length === 0) {
            setFiltrado(listaAssociados)
            return
        }

        const listaFiltrada = filtrosPreenchidos.reduce((listaAtual, filtro) => {
            return retornaListaMatchPorListaCampo(listaAtual, campoPorOpcao[filtro.campo], filtro.valor)
        }, listaAssociados)

        setFiltrado(listaFiltrada)
    }, [filtros, listaAssociados])

    const handleAdicionarFiltro = () => {
        setFiltros(filtrosAtuais => [...filtrosAtuais, criaFiltroVazio()])
    }

    const handleAlterarFiltro = (id, novoValor) => {
        setFiltros(filtrosAtuais => filtrosAtuais.map(filtro => {
            if(filtro.id !== id) return filtro
            return { ...filtro, ...novoValor }
        }))
    }

    const handleRemoverFiltro = (id) => {
        setFiltros(filtrosAtuais => {
            const novaLista = filtrosAtuais.filter(filtro => filtro.id !== id)
            return novaLista.length > 0 ? novaLista : [criaFiltroVazio()]
        })
    }

    return (
        <>
            <MultiMatchFilter
                filtros={filtros}
                itensDoSelect={opcoesDeFiltro}
                onAdicionarFiltro={handleAdicionarFiltro}
                onAlterarFiltro={handleAlterarFiltro}
                onRemoverFiltro={handleRemoverFiltro}
            />
            <GerenciarAssociados
                cadastros={filtrado}
                onClick={onClick}
                tituloToolbar={tituloToolbar}>
                {children}
            </GerenciarAssociados>
        </>
    )
}
